var React = require('react');

function TimesLarge (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 38L38 2","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2 2L38 38","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

TimesLarge.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = TimesLarge;

TimesLarge.default = TimesLarge;
